<div class="teams-tab">
  <!-- Loading State -->
  <div *ngIf="loading" class="text-center p-4">
    <i class="fa fa-spinner fa-spin fa-2x"></i>
    <p>Loading team information...</p>
  </div>

  <!-- No Team State -->
  <div *ngIf="!loading && !team && !creating" class="no-team-container">
    <div class="alert alert-info">
      <i class="fa fa-users"></i>
      Not part of a team
    </div>
    <button class="btn btn-primary" (click)="startCreatingTeam()" *ngIf="isEditMode">
      <i class="fa fa-plus"></i> Create New Team
    </button>
  </div>

  <!-- Team View/Edit -->
  <div *ngIf="!loading && (team || creating)" class="team-container">
    <div class="team-header">
      <h5>{{ creating ? "Create New Team" : "Team Information" }}</h5>
      <div class="team-actions" *ngIf="!editing && !creating">
        <button class="btn btn-sm btn-warning" (click)="startEditing()" *ngIf="isEditMode">
          <i class="fa fa-pencil"></i> Edit Team
        </button>
        <button class="btn btn-sm btn-danger" (click)="leaveTeam()" *ngIf="isEditMode">
          <i class="fa fa-sign-out"></i> Leave Team
        </button>
      </div>
      <div class="team-actions" *ngIf="editing && !creating">
        <button class="btn btn-sm btn-success" (click)="saveTeam()" [disabled]="teamSaving">
          <i class="fa fa-save"></i> {{ teamSaving ? "Saving..." : "Save Changes" }}
        </button>
        <button class="btn btn-sm btn-secondary" (click)="cancelEdit()" [disabled]="teamSaving">
          <i class="fa fa-times"></i> Cancel
        </button>
      </div>
      <div class="team-actions" *ngIf="creating">
        <button
          class="btn btn-sm btn-success"
          (click)="createTeam()"
          [disabled]="teamSaving || (team?.drivers?.length || 0) < 2"
        >
          <i class="fa fa-save"></i> {{ teamSaving ? "Creating..." : "Create Team" }}
        </button>
        <button class="btn btn-sm btn-secondary" (click)="cancelCreate()" [disabled]="teamSaving">
          <i class="fa fa-times"></i> Cancel
        </button>
      </div>
    </div>

    <div class="team-details">
      <!-- Team Name -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label">Team Name</label>
        <div class="col-md-9">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="team.name"
            [disabled]="!editing && !creating"
            placeholder="Enter team name"
            aria-label="Team name"
          />
        </div>
      </div>

      <!-- Team Type -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label">Team Type</label>
        <div class="col-md-9">
          <input type="text" class="form-control" [value]="team?.type || 'N/A'" disabled aria-label="Team type" />
        </div>
      </div>

      <!-- Team Members Table -->
      <div class="team-members">
        <div class="members-header">
          <h6>Team Members</h6>
          <button
            class="btn btn-sm btn-primary"
            data-toggle="modal"
            data-target="#addDriverModal"
            (click)="openAddDriverModal()"
            *ngIf="editing || creating"
          >
            <i class="fa fa-plus"></i> Add Driver
          </button>
        </div>

        <table class="table table-bordered">
          <thead>
            <tr>
              <th style="width: 80px; text-align: center">Pay To</th>
              <th style="width: 120px">Percent</th>
              <th>Driver Name</th>
              <th>Type</th>
              <th style="width: 80px" *ngIf="editing || creating"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let teamDriver of team?.drivers">
              <td style="text-align: center">
                <p-checkbox
                  [(ngModel)]="teamDriver.isPayTo"
                  [binary]="true"
                  [disabled]="!editing && !creating"
                  (onChange)="onPayToChange(teamDriver)"
                  ariaLabel="Pay to"
                ></p-checkbox>
              </td>
              <td>
                <div class="percent-input">
                  <input
                    [(ngModel)]="teamDriver.earningPercentage"
                    type="number"
                    min="0"
                    max="100"
                    class="form-control"
                    [disabled]="!editing && !creating"
                    (blur)="calculateTotalPercent()"
                    aria-label="Earning percentage"
                  />
                  <span>%</span>
                </div>
              </td>
              <td>
                {{ teamDriver.name }} {{ teamDriver.lastName }}
                <span *ngIf="teamDriver.id === driver.id" class="badge badge-info ml-2"
                  >This Driver</span
                >
              </td>
              <td>{{ getDisplayType(teamDriver.type) }}</td>
              <td *ngIf="editing || creating" style="text-align: center">
                <button
                  *ngIf="teamDriver.id !== driver.id"
                  class="btn btn-sm btn-danger"
                  (click)="removeDriver(teamDriver)"
                  title="Remove driver"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr class="total-row">
              <td></td>
              <td>
                <strong
                  [ngClass]="{
                    'text-success': totalPercent === 100,
                    'text-danger': totalPercent !== 100
                  }"
                >
                  {{ totalPercent }}%
                </strong>
              </td>
              <td colspan="2">Total</td>
              <td *ngIf="editing || creating"></td>
            </tr>
          </tbody>
        </table>

        <div *ngIf="totalPercent !== 100" class="alert alert-warning">
          <i class="fa fa-exclamation-triangle"></i>
          Total percentage must equal 100%. Currently: {{ totalPercent }}%
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add Driver Modal -->
<div
  class="modal fade"
  id="addDriverModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="addDriverModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addDriverModalLabel">Add Driver to Team</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closebutton>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Select Driver</label>
          <select class="form-control" [(ngModel)]="selectedDriver" aria-label="Select driver to add to team">
            <option [ngValue]="null">-- Select a driver --</option>
            <option *ngFor="let driver of availableDrivers" [ngValue]="driver">
              {{ driver.itemName }} ({{ getDisplayType(driver.type) }})
            </option>
          </select>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="addDriver()"
          [disabled]="!selectedDriver"
        >
          Add Driver
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Confirm Dialog -->
<p-confirmDialog
  header="Confirm"
  icon="pi pi-exclamation-triangle"
  [style]="{ width: '450px' }"
></p-confirmDialog>
